import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { State } from 'src/app/reducers';
import { Assessment} from '../../../store/assessment/assessment.models';
import {createUserAssessment, loadAssessments} from '../../../store/assessment/assessment.actions';
import { filter, takeUntil } from 'rxjs/operators';
import { User } from 'src/app/store/auth/auth.models';
import { Router } from '@angular/router';

@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.scss'],
})
export class CategoriesComponent implements OnInit, OnDestroy {
  private destroyer$: Subject<any> = new Subject();

  // Attachement to the store
  loadingAssessments$: Observable<boolean>;
  loadingAssessmentsError$: Observable<string>;
  allAssessments$: Observable<Assessment[]>;

  startingAssessment$: Observable<boolean>;
  startingAssessmentError$: Observable<string>;
  currentUserAssessment$: Observable<Assessment>;

  currentUser: User;

  allAssessments = [];


  constructor(private store: Store<State>, private router: Router) {
    // Attach to the store
    this.allAssessments$ = store.select((state) => state.assessments.allAssessments);
    this.loadingAssessments$ = store.select((state) => state.assessments.loadingAssessment);
    this.startingAssessment$ = store.select((state) => state.assessments.creatingUserAssessment);
    this.loadingAssessmentsError$ = store.select((state) => state.assessments.loadingAssessmentError);
    store.select(state => state.assessments.currentUserAssessment).pipe(takeUntil(this.destroyer$), filter(d => !!d)).subscribe(
      v => this.router.navigate(['/assessments', v.id, 'welcome']));
    store.select(state => state.auth.authenticatedUser).pipe(takeUntil(this.destroyer$)).subscribe(user => this.currentUser = user);
    // dispatch fetching all assessments
    this.store.dispatch(loadAssessments({ categoryId: null }));
  }

  ngOnInit(): void {
    this.allAssessments$.subscribe(values => {
      this.allAssessments = Object.keys(values).reduce((prev, next) => {
        prev = [...prev, ...values[next]];
        return prev;
      }, [])
      });

   }

  ngOnDestroy(): void {
    this.destroyer$.next(false);
    this.destroyer$.complete();
  }

  startAssessment(assessment: Assessment) {
    this.store.dispatch(createUserAssessment({userId: this.currentUser.sub, assessmentId: assessment.assessment_id, categoryId: assessment.assessmentCatID}));
  }

  totalCategoryAssessments(categoryId: string, items: Assessment[]): number {
    return items.filter(it => it.assessmentCatID === categoryId).length;
  }

  onCategoryClick(assesmentCategorie): void {
    assesmentCategorie = assesmentCategorie.replace(/\s/g, "");
    this.router.navigate(['/assessments/assesmentList', assesmentCategorie])


  }
}
